import React from 'react'
import {Helmet} from "react-helmet"
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import styled, {css, ThemeProvider} from 'styled-components'
import selectors from 'widget/store/selectors'
import Conversation from '../Conversation'
import Launcher from '../Launcher'
import { IconContext } from 'react-icons'
import TableOfContents from '../TableOfContents'
import { contrast } from 'helpers'
import { FULLSCEEN_WIDTH_BREAKPOINT } from 'src/constants'
import GlobalStyle from '../GlobalStyle'
// adds black or white color code as contrast color value to each key with color code, that value is used in a11y deciding which color to choose that contrast ratio is > 4.5
const addContrastColors = (theme) => {
  const enhanced = {...theme}
  const regex = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i

  for (const key in theme) {
    if (theme.hasOwnProperty(key) && regex.test(theme[key])) {
      const color = contrast('#F0F0F0', theme[key]) >= 4.5 ? '#F0F0F0' : '#101010'
      enhanced[`${key}ContrastColor`] = color
    }
  }
  return enhanced
}
const loadFont = theme => {
  if(!theme.fontFamily) return null
  const font = theme.fontFamily.trim().replace(/^\w/, (c) => c.toUpperCase())
  const fontUrl = `https://fonts.googleapis.com/css?family=${font}&display=swap`
  return (
    <Helmet>
      <link rel="stylesheet" type="text/css" href={fontUrl} />
    </Helmet>
  )
}
class WidgetLayout extends React.Component {
  render() {
    const {
      config,
      showChat,
      theme,
      title,
      subtitle,
      senderPlaceHolder,
      avatarBot,
      avatarUser,
      onToggleConversation,
      onCloseConversation,
      badge,
      launcher,
      isFetching,
      minimized,
    } = this.props
    const { fullScreenMode } = config

    return (
      <ThemeProvider theme={addContrastColors(theme) || {}}>
        {loadFont(theme)}
        <GlobalStyle />
        <IconContext.Provider value={{ style: { verticalAlign: 'middle' }}}>
          <WidgetContainer
            fullScreen={fullScreenMode}
            className={fullScreenMode ? 'full-screen' : ''}
            showChat={showChat}
            embedded={config.embedded}
            aria-expanded={showChat}
            aria-label={title}
          >
            {
              this.props.showChat &&
                <React.Fragment>
                  <TableOfContents />
                  <Conversation
                    title={title}
                    subtitle={subtitle}
                    senderPlaceHolder={senderPlaceHolder}
                    avatarBot={avatarBot}
                    avatarUser={avatarUser}
                    toggleChat={onToggleConversation}
                    showChat={showChat}
                    closeChat={onCloseConversation}
                    config={config}
                    theme={addContrastColors(theme)}                    />
                </React.Fragment>}
            {!fullScreenMode && !config.embedded && (
              <Launcher
                toggle={onToggleConversation}
                chatOpened={showChat}
                badge={badge}
                config={launcher}
                isFetching={isFetching}
                minimized={minimized}
                bubbleText={config.bubbleText}
                bubbleDelay={config.bubbleDelay}
              />
            )}
          </WidgetContainer>
        </IconContext.Provider>
      </ThemeProvider>)
  }
}

WidgetLayout.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onToggleConversation: PropTypes.func,
  onCloseConversation: PropTypes.func,
  showChat: PropTypes.bool,
  config: PropTypes.shape({
    apiKey: PropTypes.string,
    backend: PropTypes.string.isRequired,
    botId: PropTypes.string.isRequired,
    avatarBot: PropTypes.string,
    avatarUser: PropTypes.string,
    liveAgentAvatar: PropTypes.string,
    launcher: PropTypes.shape({
      icon: PropTypes.string,
      minimizedIcon: PropTypes.string,
      height: PropTypes.number,
    }),
    title: PropTypes.string
  }),
  senderPlaceHolder: PropTypes.string,
  avatarBot: PropTypes.string,
  avatarUser: PropTypes.string,
  fullScreenMode: PropTypes.bool,
  badge: PropTypes.number,
}


const mapStateToProps = (state, ownProps) => ({
  showChat: selectors.selectShowChat(state, ownProps),
  theme: selectors.selectTheme(state),
  isFetching: selectors.selectIsFetching(state)
})

export default connect(mapStateToProps)(WidgetLayout)
const fullScreen = css`
  height: 100%;
  margin: 0;
  width: 100%;
  position: fixed;

  .conversation-container {
    max-width: none;
    width: 100%;
  }
`

const embedded = css`
  height: 100%;
  margin: 0;
  width: 100%;
  position: static;

  .conversation-container {
    max-width: none;
    width: 100%;
  }
`

const WidgetContainer = styled.div`
  --fontFamily: ${props => props.theme.fontFamily};
  --headerFontSize: ${props => props.theme.headerFontSize};
  --messageFontSize: ${props => props.theme.messageFontSize};
  font-family: var(--fontFamily);
  bottom: 0;
  display: flex;
  margin: 0 5px 5px 0;
  position: fixed;
  right: 0;
  z-index: 1000;
  line-height: 16px;

  .toc-container {
    float: left;
    width: 300px;
  }

  .conversation-container {
    float: right;
    width: 90vw;
    max-width: 340px;
    position: relative;

    @media screen and (max-width: ${FULLSCEEN_WIDTH_BREAKPOINT}px) {
        height: 100%;
    }

    @media (max-width: 1288px) {
      max-width: 300px;
    }
  }

  ${props => props.embedded && embedded}
  ${props => props.fullScreen && fullScreen}

  ${props => props.showChat && css`
    @media screen and (max-width: ${FULLSCEEN_WIDTH_BREAKPOINT}px) {
      ${props.embedded ? '' : fullScreen}
      .toc-container {
        display: none;
      }
    }
  `}
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Widget/layout.js